// src/lib/redisClient.ts

import { createClient, RedisClientType } from "redis";

let redisClient: RedisClientType | null = null;

export interface RedisClientOptions {
  host: string;
  port: number;
  password?: string;
  connectTimeout?: number;
}

export function initRedisClient({
  host,
  port,
  password = "",
  connectTimeout = 10000,
}: RedisClientOptions) {
  if (redisClient && redisClient.isOpen) {
    console.log("⚠️ Redis client already initialized and connected.");
    return;
  }

  const config = {
    socket: {
      host,
      port,
      connectTimeout,
    },
    password,
  };

  console.log("🚀 ~ Redis config:", config);

  redisClient = createClient(config);

  redisClient.on("error", (err: any) => {
    console.error(`❌ Redis connection error (${host}):`, err);
  });

  (async () => {
    try {
      if (!redisClient!.isOpen) {
        await redisClient!.connect();
        console.log(`✅ Redis connected to ${host}:${port}`);
      }
    } catch (error) {
      console.error("❌ Failed to connect to Redis:", error);
    }
  })();
}

export function getRedisClient(): RedisClientType {
  if (!redisClient) {
    throw new Error("Redis client not initialized. Call initRedisClient() first.");
  }
  return redisClient;
}

export async function closeRedisClient() {
  if (redisClient && redisClient.isOpen) {
    await redisClient.quit();
    console.log("🛑 Redis connection closed.");
    redisClient = null;
  }
}